import { NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, TemplateRef, computed, input, inject } from '@angular/core';
import { RouterLink } from '@angular/router';

import { UrlTarget } from '@ppg/core/enums';
import { UrlCtaService } from '@ppg/shared/utils';

@Component({
  selector: 'ppg-cta-card-template',
  standalone: true,
  imports: [NgTemplateOutlet, RouterLink],
  templateUrl: './cta-card-template.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CtaCardTemplateComponent {
  readonly #urlCtaService = inject(UrlCtaService);

  readonly template = input.required<TemplateRef<string>>();
  readonly url = input<string>('');
  readonly target = input<UrlTarget>();

  readonly #urlParts = computed(() => this.#urlCtaService.parseUrl(this.url()));

  readonly anchor = computed(() => this.#urlParts().anchor);
  readonly urlForRelativePath = computed(() => this.#urlParts().path);
  readonly queryParams = computed(() => this.#urlParts().queryParams);

  readonly isPathRelativeWithSelfTarget = computed(() =>
    this.#urlCtaService.isRelativePathWithSelfTarget(this.url(), this.target()),
  );
}
